"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTile = exports.moveToXY = exports.create = exports.neighborOffsets = exports.neighborsDiagonal = exports.neighbors8 = exports.neighbors4 = exports.ETilemapNeighbor = void 0;
var deepFreeze_1 = require("@engine/deepFreeze");
var diveTileData_1 = require("./diveTileData");
var diveTileData_sidecar_1 = require("./diveTileData-sidecar");
var ETilemapNeighbor;
(function (ETilemapNeighbor) {
    ETilemapNeighbor[ETilemapNeighbor["N"] = 0] = "N";
    ETilemapNeighbor[ETilemapNeighbor["E"] = 1] = "E";
    ETilemapNeighbor[ETilemapNeighbor["S"] = 2] = "S";
    ETilemapNeighbor[ETilemapNeighbor["W"] = 3] = "W";
    ETilemapNeighbor[ETilemapNeighbor["NE"] = 4] = "NE";
    ETilemapNeighbor[ETilemapNeighbor["SE"] = 5] = "SE";
    ETilemapNeighbor[ETilemapNeighbor["SW"] = 6] = "SW";
    ETilemapNeighbor[ETilemapNeighbor["NW"] = 7] = "NW";
})(ETilemapNeighbor = exports.ETilemapNeighbor || (exports.ETilemapNeighbor = {}));
exports.neighbors4 = [
    ETilemapNeighbor.N,
    ETilemapNeighbor.E,
    ETilemapNeighbor.S,
    ETilemapNeighbor.W,
];
exports.neighbors8 = [
    ETilemapNeighbor.N,
    ETilemapNeighbor.E,
    ETilemapNeighbor.S,
    ETilemapNeighbor.W,
    ETilemapNeighbor.NE,
    ETilemapNeighbor.SE,
    ETilemapNeighbor.SW,
    ETilemapNeighbor.NW,
];
exports.neighborsDiagonal = [
    ETilemapNeighbor.NE,
    ETilemapNeighbor.SE,
    ETilemapNeighbor.SW,
    ETilemapNeighbor.NW,
];
exports.neighborOffsets = [
    [0, -1],
    [1, 0],
    [0, 1],
    [-1, 0],
    [1, -1],
    [1, 1],
    [-1, 1],
    [-1, -1],
];
deepFreeze_1.deepFreeze(exports.neighborOffsets);
function create(i, j, x, y) {
    // let image1 = spritesUtil.createImage(
    //   voyageLayers.getLayers().ship1,
    //   sprites.voyTileChecker1[0],
    // )
    // image1.tint = voyageColors.g2
    var tile1 = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Floor);
    // let tile2 = voyageTileData.get(EDiveTile.Null2)
    // let tile3 = voyageTileData.get(EDiveTile.Null3)
    var obj = {
        i: i,
        j: j,
        x: x,
        y: y,
        isRoom: false,
        isCentralHallway: false,
        shadow: 0,
        // flickerTimer: 0,
        // flickerState: 0,
        variant: 0,
        // image1,
        // image2: null,
        // image3: null,
        // imageBreach: null,
        // imageSystem: null,
        tile1: tile1,
        // colorIdx1: 0,
        // subTileIdx1: 0,
        // tile2,
        // colorIdx2: 0,
        // subTileIdx2: 0,
        // tile3,
        // colorIdx3: 0,
        // subTileIdx3: 0,
        // text3: '',
        // text: null,
        // fire: null,
        // breach: null,
        // system: null,
        // items: [],
        // crew: [],
        neighbors: [null, null, null, null, null, null, null, null],
        visibilityIdx: 0,
        gen_doorHint: '',
        objects: [],
        crew: [],
    };
    moveToXY(obj, x, y);
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    // obj.image1.x = x
    // obj.image1.y = y
    // if (obj.image2) {
    //   obj.image2.x = x
    //   obj.image2.y = y
    // }
    // if (obj.image3) {
    //   obj.image3.x = x
    //   obj.image3.y = y
    // }
}
exports.moveToXY = moveToXY;
function setTile(obj, 
//layer: number,
data) {
    obj.tile1 = data;
    // let img = obj.image2
    // let layer = data.layer
    // subTileIdx = mathUtils.wrapIndex(subTileIdx, data.frames)
    // colorIdx = mathUtils.wrapIndex(colorIdx, data.colors)
    // if (layer === 1) {
    //   img = obj.image1
    //   obj.tile1 = data
    //   obj.subTileIdx1 = subTileIdx
    //   obj.colorIdx1 = colorIdx
    // }
    // if (layer === 2) {
    //   if (!obj.image2 && !data.isNull) {
    //     obj.image2 = spritesUtil.createImage(
    //       voyageLayers.getLayers().ship2,
    //       sprites.voyTileNull[0],
    //     )
    //     obj.image2.x = obj.x
    //     obj.image2.y = obj.y
    //   }
    //   img = obj.image2
    //   obj.tile2 = data
    //   obj.subTileIdx2 = subTileIdx
    //   obj.colorIdx2 = colorIdx
    // }
    // if (layer === 3) {
    //   if (!obj.image3 && !data.isNull) {
    //     obj.image3 = spritesUtil.createImage(
    //       voyageLayers.getLayers().ship3,
    //       sprites.voyTileNull[0],
    //     )
    //     obj.image3.x = obj.x
    //     obj.image3.y = obj.y
    //   }
    //   img = obj.image3
    //   obj.tile3 = data
    //   obj.subTileIdx3 = subTileIdx
    //   obj.colorIdx3 = colorIdx
    // }
    // if (!data.isNull) {
    //   assert.notNil(img, 'somehow image is null')
    //   spritesUtil.setPackedFrame(img, data.frames[subTileIdx])
    //   //img.pi
    //   //spritesUtil.scale(img, 3)
    //   img.tint = data.colors[colorIdx]
    //   img.visible = true
    // } else {
    //   if (img) {
    //     img.visible = false
    //   }
    // }
}
exports.setTile = setTile;
// export function setText(obj: IVoyageTilemapPart, text: string) {
//   obj.text3 = text
//   if (!obj.text && text) {
//     obj.text = stevieTexts2.create(
//       echoFonts.getData().font4,
//       0,
//       0,
//       voyageLayers.getLayers().ship3,
//     )
//     stevieTexts2.setScale(obj.text, 3)
//   }
//   if (obj.text) {
//     stevieTexts2.setText(obj.text, text)
//     stevieTexts2.moveTo(obj.text, obj.x, obj.y)
//   }
// }
// export function setHullBreach(obj: IVoyageTilemapPart, isBreach: boolean) {
//   if (isBreach) {
//     if (!obj.imageBreach) {
//       obj.imageBreach = spritesUtil.createImage(
//         voyageLayers.getLayers().ship3,
//         sprites.voyTileChecker2[0],
//       )
//       obj.imageBreach.x = obj.x
//       obj.imageBreach.y = obj.y
//       obj.imageBreach.tint = voyageColors.damage
//     }
//   } else {
//     if (obj.imageBreach) {
//       obj.imageBreach.destroy()
//       obj.imageBreach = null
//     }
//   }
// }
// export function setSystemImage(
//   t: IVoyageTilemapPart,
//   frame: ISPD | null,
//   tint: number = 0xffffff,
// ) {
//   if (!frame) {
//     if (t.imageSystem) {
//       t.imageSystem.destroy()
//       t.imageSystem = null
//     }
//   } else {
//     if (!t.imageSystem) {
//       t.imageSystem = spritesUtil.createImage(
//         voyageLayers.getLayers().ship4,
//         frame,
//       )
//       t.imageSystem.x = t.x
//       t.imageSystem.y = t.y
//     } else {
//       spritesUtil.setPackedFrame(t.imageSystem, frame)
//     }
//     t.imageSystem.tint = tint
//   }
// }
